import { StatutPeriodeEvaluation } from 'app/shared/model/periode-evaluation.model';
import { ScoringMode } from 'app/shared/model/cycle.model';
import { MatiereBulletin } from './bulletins.types';

export const KORI_ORANGE = '#F28E19';

export const normalizeTo20 = (value: number, bareme?: number) => {
  if (bareme && bareme > 0) {
    return (value * 20) / bareme;
  }
  return value;
};

export const getMention = (moyenne?: number | null) => {
  if (moyenne === null || moyenne === undefined) return '-';
  if (moyenne >= 16) return 'Très bien';
  if (moyenne >= 14) return 'Bien';
  if (moyenne >= 12) return 'Assez bien';
  if (moyenne >= 10) return 'Passable';
  return 'Insuffisant';
};

export const format2 = (value?: number | null) => {
  if (value === null || value === undefined || Number.isNaN(value)) return '-';
  return value.toFixed(2);
};

export const getPeriodeSortRank = (periode: { ordre?: number | null; dateFin?: string | null }) => {
  if (typeof periode.ordre === 'number') return periode.ordre;
  if (periode.dateFin) {
    const timestamp = Date.parse(periode.dateFin);
    if (Number.isFinite(timestamp)) return timestamp;
  }
  return -1;
};

export const usesCoefficients = (mode?: ScoringMode | string | null) => mode === ScoringMode.COEFFICIENT;

export const coefficientBulletinRows = (matieres: MatiereBulletin[]) =>
  matieres.reduce<MatiereBulletin[]>((rows, matiere) => {
    rows.push(matiere);
    const detailed = matiere.coefficientSource === 'SOUS_MATIERES';
    (matiere.sousMatieres || []).forEach(child =>
      rows.push({
        ...child,
        matiereId: matiere.matiereId,
        matiereNom: `↳ ${child.sousMatiereNom}`,
        coefficient: detailed ? child.coefficient : null,
        moyenneApresCoefficient: detailed ? child.points : null,
        appreciation: child.dispense ? 'Dispensé' : child.moyenneSur20 == null ? 'Sans note calculable' : '',
      })
    );
    return rows;
  }, []);
